import RulesInfo from './RulesInfo';

export default RulesInfo;



// WEBPACK FOOTER //
// ./src/components/RulesInfo/index.js